<script setup lang="ts">
const props = defineProps<{ locale: string }>();
const route = useRoute();
const isDocs = computed(() => route.path.includes("docs"));

// Plain <a> (NOT NuxtLink) on purpose: this markup is slotted into
// <e-mega-menu>, whose package SSR serializer re-emits slot content as an
// HTML string. It can't resolve Vue components, so a <NuxtLink> came out of
// SSR as a literal unresolved `<RouterLink>` tag — every page then hydration-
// mismatched in the header and Vue remounted the whole bar (logo pop = layout
// shift). The @click.prevent handlers keep navigation on the SPA router.

// Shares the `sections` cache with other header components — single fetch.
const sections = useSections(computed(() => props.locale));
</script>

<template>
  <div class="flex items-end gap-2">
    <a :href="`/${locale}`" @click.prevent="navigateTo(`/${locale}`)">
      <e-logo color="accent" alt="eConnect"
        class="block w-48 h-10 part-[base]:h-full part-[base]:w-full part-[base]:object-contain cursor-pointer"
        @click.stop.prevent="navigateTo(`/${locale}`)"></e-logo>
    </a>
    <a :href="`/${locale}/docs`" v-show="isDocs" class="font-heading font-bold text-lg leading-4 mb-1.5"
      @click.prevent="navigateTo(`/${locale}/docs`)">/ docs
    </a>
  </div>
</template>
